/**
 * Check if two arrays are equal
 * @param {Array} arr1 - first array
 * @param {Array} arr2 - second array
 * @returns {Boolean}
 */
export const areEqual = (arr1, arr2) => {
  if (arr1 === null || arr2 === null) return false;
  if (arr1.length !== arr2.length) return false;
  if (arr1 === arr2) return true;

  // last resort, check each item
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
};

/**
 * Flatten array of arrays into a single array
 * @param {Array[]} arr
 * @returns {Array}
 */
export const flatten = arrays => [].concat.apply([], arrays);

/**
 * Minimize the number of arrays in a array
 *
 * The goal of this algorithm is to the reduce the number of arrays in an array
 * by combining arrays with empty indicies.
 *
 * Example:
 * arr = [
 *  [1, '', ''],
 *  [2, '', ''],
 *  ['', 3, ''],
 *  ['', 4, ''],
 *  ['', '', 5],
 * ]
 *
 * arr = [
 *  [1, 3, 5],
 *  [2, 4, '']
 * ]
 *
 * @param {Array[]} arrayOfArrys
 * @param {*} emptyValue - value that will be used to check if a value at an index is considered empty. Default value is an empty string
 */
export const minimizeArrays = (arrayOfArrys, emptyValue = '') => {
  let arr = arrayOfArrys;
  let outcome = [];

  for (let i = 0; i < arr.length; i++) {
    if (i === 0) {
      outcome.push(arr[i]);
      continue;
    }

    let arrayToCheck = arr[i];
    for (let j = 0; j < arrayToCheck.length; j++) {
      const value = arrayToCheck[j];

      if (value !== emptyValue) {
        let k = 0;
        let pushNewArray = true;

        while (k < outcome.length) {
          if (outcome[k][j] === emptyValue) {
            outcome[k][j] = arrayToCheck[j];
            pushNewArray = false;
            break;
          }

          k += 1;
        }

        if (pushNewArray) {
          outcome.push(arrayToCheck);
        }
      }
    }
  }

  return outcome;
};
